module.exports = __webpack_public_path__ + "static/img/dice_1.9bc61c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lottery/dice/dice_1.png
// module id = hO4o
// module chunks = 23